export type MappingStatus = "not_started" | "pending" | "in_progress" | "done";
export type PILStatus = "pending" | "in_progress" | "done" | "rejected" | "admin_approved";

export function statusColor(status: MappingStatus | PILStatus | string): string {
  switch (status) {
    case "admin_approved":
      return "#16a34a";
    case "done":
      return "#22c55e";
    case "in_progress":
      return "#f59e0b";
    case "pending":
      return "#3b82f6";
    case "rejected":
    case "not_started":
    default:
      return "#9ca3af";
  }
}

export function statusLabel(status: MappingStatus | PILStatus | string): string {
  switch (status) {
    case "admin_approved":
      return "Approved";
    case "done":
      return "Done";
    case "in_progress":
      return "In progress";
    case "pending":
      return "Pending";
    case "not_started":
      return "Not started";
    default:
      return status;
  }
}

export function statusChipClass(status: MappingStatus | PILStatus | string): string {
  switch (status) {
    case "admin_approved":
      return "bg-green-200 text-green-900 border-green-300 dark:bg-green-900 dark:text-green-100 dark:border-green-800";
    case "done":
      return "bg-green-100 text-green-800 border-green-200 dark:bg-green-950 dark:text-green-200 dark:border-green-900";
    case "in_progress":
      return "bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-950 dark:text-amber-200 dark:border-amber-900";
    case "pending":
      return "bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-950 dark:text-blue-200 dark:border-blue-900";
    case "not_started":
    default:
      return "bg-gray-100 text-gray-700 border-gray-200 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-800";
  }
}
